import { axiosClient, TPagination } from "@/configurations/axios"

import { queryClient } from "@/configurations/react-query"
import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query"
import { SESSION_ENDPOINTS, SESSION_KEYS } from "../configs/endpoints"
import { TParamsGetSession, TSession } from "../types"

export const getSessionList = async (params: TParamsGetSession) => {
  const response = await axiosClient.get<TPagination<TSession>>(
    SESSION_ENDPOINTS.getSession,
    {
      params
    }
  )
  return response.data
}

export const useGetSessionList = (params: TParamsGetSession) => {
  return useInfiniteQuery({
    queryKey: SESSION_KEYS.getSessionWithParams(params),
    queryFn: ({ pageParam = 1 }) => {
      params.pageNumber = pageParam as number
      return getSessionList(params)
    },
    enabled: !!params,
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const nextPage = lastPage.pageNumber + 1
      return nextPage <= lastPage.totalPages ? nextPage : undefined
    },
    select: data => data.pages.flatMap(page => page.data) ?? []
  })
}

export const getSessionListQueryOptions = (params: TParamsGetSession) => {
  return infiniteQueryOptions({
    queryKey: SESSION_KEYS.getSessionWithParams(params),
    queryFn: ({ pageParam = 1 }) => {
      params.pageNumber = pageParam as number
      return getSessionList(params)
    },
    enabled: !!params,
    refetchOnWindowFocus: true,
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const nextPage = lastPage.pageNumber + 1
      return nextPage <= lastPage.totalPages ? nextPage : undefined
    },
    select: data => data.pages.flatMap(page => page.data) ?? []
  })
}
export const getSessionListLoader = (param: TParamsGetSession) => {
  return queryClient.ensureInfiniteQueryData(getSessionListQueryOptions(param))
}
